// extracted by mini-css-extract-plugin
module.exports = {"InformationTag":"styles_InformationTag__YhwPq"};